import '../../../../campaign/js/components/dropdown/index.scss';

const COMPONENT = '.wrapper-dropdown-3';

const dropdowns = [];
let initialized = false;

/**
 * @param $context
 *
 * @return {Dropdown[]}
 */
export default ($context) => {
  if (!$context.length)
  {
    return [];
  }

  init();

  return $context.find(COMPONENT).map((index, component) => new Dropdown(component));
};

function init() {
  if (initialized)
  {
    return;
  }

  $(document).on('click', () => {
    $(dropdowns).removeClass('active');
  });

  initialized = true;
}

function Dropdown(component) {
  if (dropdowns.indexOf(component) === -1)
  {
    dropdowns.push(component);
  }

  const $component = $(component);
  const $placeholder = $component.children('span');
  const $options = $component.find('ul.dropdown > li');

  let _index = -1;
  let _value;

  $component.on('click', () => {
    $component.toggleClass('active');

    return false;
  });

  $options.on('click', function() {
    const option = $(this);
    _value = option.text();
    _index = option.index();

    $placeholder.text(_value);
  });

  this.getIndex = () => {
    return _index;
  };

  this.getValue = () => {
    return _value;
  };

  this.selectIndex = (index) => {
    _index = index;
    _value = $($options[index]).text();

    $placeholder.text(_value);
  };
}
